import { popupModalJsFiles } from "../build/popupModalJsFiles";
import { popupModalCssFiles } from "../build/popupModalCssFiles";
import { Config } from "../../../public/js/react/utils/config";
import compiledTemplate from "../templates/popupModal.handlebars";
const urlParams = new URLSearchParams(document.location.search);
const forceBundle = urlParams.get("forcebundle");
const touchscreen = urlParams.get("touchscreen");
const noTrack = urlParams.get("notrack") || false;
window.addEventListener("load", function() {
  var env = Config.isDevEnv() ? "dev" : "prod";
  var envName = Config.getEnvironment();
  var js = [];
  var css = [];
  var bundle = forceBundle ? "bundled" : Config.isDevEnv() ? "unbundled" : "bundled";
  js = js.concat(popupModalJsFiles[bundle][env]);
  css = css.concat(popupModalCssFiles[bundle][env]);
  document.open();
  document.write(
    compiledTemplate({
      js,
      css,
      noTrack,
      config: Config.getEnvironmentVariables(),
      isDev: Config.isDevEnv(),
      touchscreen
    })
  );
  document.close();
});
